// extracted by mini-css-extract-plugin
export default {"BetaFeatureNotice__give-feedback":"xEqQEfy_tpVAduDtmzx1"};